export default __webpack_public_path__ + "static/media/bird-jay-animated-moving.f4989985.svg";